import React, { Fragment } from 'react';
import clsx from 'clsx';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import BaseButton from '../Buttons/BaseButton';
import FlatButton from '../Buttons/FlatButton';
import CloseIcon from '../CustomIcons/CloseIcon';

import SimpleDivider from '../Dividers/SimpleDivider';
import { useCallback } from 'react';

const CallToConfirmDialog = ({
  title,
  disableBackdropClick = false,
  paperClass = {},
  onBack = () => {},
  onAccept = () => {},
  onDeny = () => {},
  acceptText = 'Aceptar',
  denyText = 'Cancelar',
  content = null,
  contentStyle,
  contentSize,
  loading = false,
  titleStyle,
  titleTextStyle,
  titleButtonStyle,
  ...rest
}) => {
  const classes = useStyles();

  const renderDialogActions = useCallback(() => {
    return (
      <>
        <FlatButton className={classes.actionButton} onClick={onDeny}>
          {denyText}
        </FlatButton>

        <BaseButton className={classes.actionButton} onClick={onAccept}>
          {acceptText}
        </BaseButton>
      </>
    );
  }, [onAccept, onDeny, classes.actionButton, denyText, acceptText]);

  const renderDialogContent = useCallback(() => {
    return (
      <>
        <Typography paragraph className={classes.dialogText}>
          Realizar pagos en línea fácilmente.
        </Typography>
      </>
    );
  }, [classes.dialogText]);

  return (
    <Dialog
      disableBackdropClick={disableBackdropClick}
      onClose={onBack}
      classes={{
        paper: clsx(classes.paper, paperClass)
      }}
      {...rest}
    >
      <DialogTitle
        disableTypography
        className={clsx([classes.title, titleStyle])}
      >
        <Typography className={clsx([classes.titleText, titleTextStyle])}>
          {title}
        </Typography>
        <IconButton
          size="small"
          aria-label="cerrar diálogo"
          onClick={onDeny}
          className={clsx([classes.titleButton, titleButtonStyle])}
        >
          <CloseIcon size={15} className={classes.titleIcon} />
        </IconButton>
      </DialogTitle>
      <SimpleDivider withoutMargin />
      <DialogContent
        className={clsx(
          {
            [classes.contentLoading]: loading,
            [classes.contentLoaded]: !loading,
            [classes.smallContent]: contentSize === 'small',
            [classes.mediumContent]: contentSize === 'medium',
            [classes.largeContent]: contentSize === 'large'
          },
          contentStyle
        )}
      >
        {content ? content() : renderDialogContent()}
      </DialogContent>

      <Fragment>
        <SimpleDivider withoutMargin />

        <DialogActions
          className={clsx([classes.actions, classes.baseDialogActions])}
        >
          {renderDialogActions()}
        </DialogActions>
      </Fragment>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: theme.custom.borderRadius,
    overflowX: 'hidden',
    maxWidth: 400,
    width: '95%',
    fontSize: 16,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      fontSize: 15
    }
  },
  dialogText: {
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      fontSize: 14
    }
  },
  baseDialogActions: {
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      flexDirection: 'column',
      padding: theme.spacing(2)
    },
    justifyContent: 'space-between',
    padding: theme.spacing(2, 4),
    width: '90%',
    alignSelf: 'self-end'
  },
  actionButton: {
    '&:nth-child(2)': {
      margin: 0
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      '&:first-child': {
        marginTop: theme.spacing(2),
        order: 1
      },
      '&:nth-child(2)': {
        order: 0
      }
    }
  },
  actions: {
    padding: theme.spacing(2)
  },
  titleText: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  contentLoading: {
    minHeight: 200,
    paddingTop: theme.spacing(4) - 4,
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  },
  contentLoaded: {
    minHeight: 200,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  },
  smallContent: {
    width: 488,
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  mediumContent: {
    width: 600,
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  largeContent: {
    width: '100%',
    height: '100dvh',
    overflowY: 'hidden',
    padding: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '100%'
    }
  }
}));

export default CallToConfirmDialog;
